"use client";

import React, { Component } from "react";
import { requestError, requestSuccess } from "utils/requestHandler";
import { Get, Post, Delete } from "utils/axios";
import { getItem } from 'utils/tokenStore'
import i18n from 'i18n'
import _ from 'lodash';

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      devices: [],
      deviceConfigs: [],
      deviceConfig: null,
      selectedDeviceConfig: null,
      deviceConfigScope: null,
      deviceConfigPushStatus: null,
    };

    onChangeHOC = (key, val) => this.setState({ [key]: val });

    load = (param) => this.setState({ loading: param });

    getDeviceConfigs = () => {
      Get(
        `/api/device-config`,
        this.getDeviceConfigsSuccess,
        error => requestError(error),
        this.load
      )
    }

    getDeviceConfigsSuccess = payload => {
      this.setState({ deviceConfigs: payload.DATA })
    }

    addDeviceConfig = (version, description, configJson) => {
      Post(
        `/api/device-config`,
        { version, description, config_json: configJson },
        this.addDeviceConfigSuccess,
        error => requestError(error),
        this.load
      )
    }

    addDeviceConfigSuccess = payload => {
      if (payload?.RESULT === false) {
        requestError(payload.ERROR || i18n.t('DeviceConfigPage.messages.addFailed'))
        return
      }
      requestSuccess(i18n.t('DeviceConfigPage.messages.added'))
      this.getDeviceConfigs()
    }

    deleteDeviceConfig = (version) => {
      Delete(
        `/api/device-config/${version}`,
        this.deleteDeviceConfigSuccess,
        error => requestError(error),
        this.load
      )
    }

    deleteDeviceConfigSuccess = payload => {
      requestSuccess(i18n.t('DeviceConfigPage.messages.deleted'))
      this.getDeviceConfigs()
    }

    getDevices = () => {
      Post(
        `/api/getRegDevices`,
        {},
        this.getDevicesSuccess,
        error => requestError(error),
        this.load
      )
    }

    getDevicesSuccess = payload => {
      this.setState({ devices: payload.DATA })
    }

    getDeviceConfigScope = (version) => {
      Get(
        `/api/device-config/${version}/scope`,
        this.getDeviceConfigScopeSuccess,
        error => requestError(error),
        this.load
      )
    }

    getDeviceConfigScopeSuccess = payload => {
      this.setState({ deviceConfigScope: payload })
    }

    updateDeviceConfigScope = (version, applyToAll, deviceIds) => {
      Post(
        `/api/device-config/${version}/scope`,
        {
          version,
          apply_to_all: applyToAll,
          device_ids: deviceIds,
        },
        this.updateDeviceConfigScopeSuccess,
        error => requestError(error),
        this.load
      )
    }

    updateDeviceConfigScopeSuccess = payload => {
      requestSuccess(i18n.t('DeviceConfigPage.messages.scopeUpdated'))
      this.getDeviceConfigs()
    }

    pushDeviceConfig = (version) => {
      Post(
        `/api/device-config/${version}/push`,
        {},
        this.pushDeviceConfigSuccess,
        error => requestError(error),
        this.load
      )
    }

    pushDeviceConfigSuccess = payload => {
      const failedMacs = payload?.FAILED_MACS || []
      const publishedMacs = payload?.PUBLISHED_MACS || []
      if (!payload?.RESULT || failedMacs.length > 0) {
        requestError(
          i18n.t('DeviceConfigPage.messages.pushFailed', { count: failedMacs.length, macs: failedMacs.join(', ') })
        )
        return
      }
      requestSuccess(i18n.t('DeviceConfigPage.messages.pushConfirmed', { count: publishedMacs.length }))
    }

    getDeviceConfigPushStatus = (version) => {
      Get(
        `/api/device-config/${version}/push-status`,
        this.getDeviceConfigPushStatusSuccess,
        error => requestError(error),
        this.load
      )
    }

    getDeviceConfigPushStatusSuccess = payload => {
      this.setState({ deviceConfigPushStatus: payload })
    }

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoading={this.state.loading}
          onChangeHOC={this.onChangeHOC}
          getDeviceConfigs={this.getDeviceConfigs}
          addDeviceConfig={this.addDeviceConfig}
          deleteDeviceConfig={this.deleteDeviceConfig}
          getDevices={this.getDevices}
          getDeviceConfigScope={this.getDeviceConfigScope}
          updateDeviceConfigScope={this.updateDeviceConfigScope}
          pushDeviceConfig={this.pushDeviceConfig}
          getDeviceConfigPushStatus={this.getDeviceConfigPushStatus}
        />
      );
    };
  }
  return WithHOC;
};

export default HOC;
